module.exports = __webpack_public_path__ + "media/Sunny_Travel-Nico_Staf.e62c27cd.mp3";